import {
  HISTORY_FILTER_VOICEMAIL_COUNT,
  PLAYBACK_MEDIA_URL_SET,
  UPDATE_NORMAL_VOICEMAIL,
  VOICEMAIL_RESET,
  VOICEMAIL_SET,
} from "../constants/action-types";

export function voicemailReset(lastVoicemail = null) {
  return {
    type: VOICEMAIL_RESET,
    lastVoicemail,
  };
}

export function setVoicemailState(voicemail: any) {
  return {
    type: VOICEMAIL_SET,
    voicemail,
  };
}

export function setMediaPlaybackUrl(playbackMediaURL: any) {
  return {
    type: PLAYBACK_MEDIA_URL_SET,
    playbackMediaURL,
  };
}

export function updateNormalvoicemail(voicemail: any) {
  return {
    type: UPDATE_NORMAL_VOICEMAIL,
    voicemail,
  };
}

export function setHistoryfilterVoicemailCount(voicemailCount: number) {
  return {
    type: HISTORY_FILTER_VOICEMAIL_COUNT,
    voicemailCount,
  };
}
